var _path, _g, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubbleGroup2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 91,
    viewBox: "0 0 167 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2325_107)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2325_107",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -82,
    width: 167,
    height: 167
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 -82C37.3842 -82 0 -44.6158 0 1.5C0 47.6158 37.3842 85 83.5 85C129.616 85 167 47.6158 167 1.5C167 -44.6158 129.616 -82 83.5 -82Z",
    fill: "#657DF1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2325_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-59.2714 115.887L191.602 115.887L191.602 -0.789276L-59.2714 -0.789276L-59.2714 115.887Z",
    fill: "#657DF1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126 91C137.046 91 146 82.0457 146 71C146 59.9543 137.046 51 126 51C114.954 51 106 59.9543 106 71C106 82.0457 114.954 91 126 91Z",
    fill: "#F9DF1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.855 60.23C139.301 54.679 133.08 51 126 51C114.954 51 106 59.954 106 71C106 74.691 107 78.148 108.743 81.116C121.794 76.982 133.456 69.728 142.855 60.23Z",
    fill: "#203864"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2325_107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 91,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleGroup2);
export default __webpack_public_path__ + "static/media/BubbleGroup2.9782320e01629fe6152183c0bd18017f.svg";
export { ForwardRef as ReactComponent };